import { UserAccount } from "../UserAccount/UserAccount";
import "./Header.css";
import DarkModeToggle from "./DarkModeToggle";
import Search from "./Search";
import LogoIconLight from "../../assets/logo_kystverket-sekundar-cmyk.svg?react";
import LogoIconDark from "../../assets/logo_kystverket-sekundar-neg.svg?react";

import ClipboardIcon from "../../assets/versionControl/clipboard.svg?react";
import HamburgerPlussIcon from "../../assets/header/hamburger_pluss.svg?react";
import HamburgerIcon from "../../assets/header/hamburger.svg?react";

import { getVersionName, isDefaultVersion } from "../../utils/versioningUtils";
import { useDispatch, useSelector } from "react-redux";
import { setLeftPanelActiveTab } from "../../store/appSlice";
import { StoreState } from "../../store/rootReducer";
import NfsButton from "../genericComponents/NfsButton/NfsButton";
import { AppConfig } from "../../AppConfig";
import { getAGEToken } from "../../utils/authenticate";
import Alerts from "../Alerts/Alerts";
import { LeftPanelTabs } from "../../constants/Panels";
import { useContext, useState } from "react";
import { Popover } from "react-tiny-popover";
import LeftHeaderMenu from "./LeftHeaderMenu";
import RightHeaderMenu from "./RightHeaderMenu";
import ErrorReporter from "../ErrorReporter/ErrorReporter";
import { VersionContext } from "../../Context";

const Header = () => {
    const dispatch = useDispatch();

    const versionContext = useContext(VersionContext);
    const versionServiceRef = versionContext?.versionServiceRef.value;

    const [leftMenuOpen, setLeftMenuOpen] = useState(false);
    const [rightMenuOpen, setRightMenuOpen] = useState(false);
    const [errorReporterOpen, setErrorReporterOpen] = useState(false);

    const versionInfo = useSelector((state: StoreState) => state.version.versionInfo);

    const openVersionManagement = () => {
        dispatch(setLeftPanelActiveTab(LeftPanelTabs.VERSIONS));
    };

    const showVersionName = (fullLength: boolean) => {
        let versionName = "";
        if (versionInfo) {
            versionName = getVersionName(versionInfo);
            if (versionName.length > 20 && !fullLength) {
                versionName = versionName.substring(0, 30) + "...";
            }
        }
        return versionName;
    };

    const downloadBoatClient = async () => {
        const url = AppConfig.NFSAPI.BaseApiUrl + "boatclient/files/install-NFS.zip?token=" + (await getAGEToken());
        window.open(url);
    };

    return (
        <div className="header-container">
            <div className="header-logo" title={AppConfig.Version}>
                <LogoIconLight className="header-logo-icon" />
                <LogoIconDark className="header-logo-icon-dark" />
                <span className="header-title">NAUTISK FAGSYSTEM</span>
                {AppConfig.Environment !== "Production" && (
                    <span className="environment-label">{AppConfig.Environment.toUpperCase()}</span>
                )}
            </div>
            <div className="header-menu small-gap">
                {/* Version: {AppConfig.Version} - {AppConfig.Environment} */}
                {/* <button onClick={toggleVersionManagement}>Toggle version management</button> */}
                <Popover
                    containerStyle={{ zIndex: "12" }}
                    positions={["bottom"]}
                    isOpen={leftMenuOpen}
                    onClickOutside={() => setLeftMenuOpen(false)}
                    content={<LeftHeaderMenu onClose={() => setLeftMenuOpen(false)} />}
                >
                    <button className="nfs-button outline" onClick={() => setLeftMenuOpen(!leftMenuOpen)}>
                        <HamburgerPlussIcon />
                        <span>Katalog</span>
                    </button>
                </Popover>
                <Search />
                <Popover
                    containerStyle={{ zIndex: "12" }}
                    positions={["bottom"]}
                    isOpen={rightMenuOpen}
                    onClickOutside={() => setRightMenuOpen(false)}
                    content={
                        <RightHeaderMenu
                            onClose={() => setRightMenuOpen(false)}
                            onOpenErrorReporter={() => setErrorReporterOpen(true)}
                        />
                    }
                >
                    <button className="nfs-button outline" onClick={() => setRightMenuOpen(!rightMenuOpen)}>
                        <HamburgerIcon />
                        <span>Meny</span>
                    </button>
                </Popover>
                <button title={showVersionName(true)} className="header-version-button" onClick={openVersionManagement}>
                    <ClipboardIcon />
                    <span>
                        {showVersionName(false)}
                        {versionServiceRef?.current && isDefaultVersion(versionInfo, versionServiceRef?.current)
                            ? " (Planroot)"
                            : ""}
                    </span>
                </button>
            </div>
            <ErrorReporter isOpen={errorReporterOpen} onClose={() => setErrorReporterOpen(false)} />
            <div className="header-actions">
                <NfsButton outlined={true} onClick={downloadBoatClient}>
                    Båtklient
                </NfsButton>
                <DarkModeToggle />
                <Alerts />
                <UserAccount />
            </div>
        </div>
    );
};

export default Header;
